export default "__VITE_ASSET__D3wMf5we__"